import { PLACEMENT_POSITIONS } from '../../Multiplatform/LineItemForms/fields'
import {
  OUTCOME_AWARENESS,
  OUTCOME_ENGAGEMENT,
  OUTCOME_SALES,
  OUTCOME_LEADS,
  OUTCOME_TRAFFIC,
  OUTCOME_APP_PROMOTION
} from '../../../constants/campaigns'
import {
  AUDIENCE_NETWORK_CLASSIC,
  AUDIENCE_NETWORK_INSTREAM_VIDEO,
  AUDIENCE_NETWORK_REWARDED_VIDEO,
  FACEBOOK_BIZ_DISCO_FEED,
  FACEBOOK_FACEBOOK_REELS,
  FACEBOOK_FACEBOOK_REELS_OVERLAY,
  FACEBOOK_FEED,
  FACEBOOK_INSTANT_ARTICLE,
  FACEBOOK_INSTREAM_VIDEO,
  FACEBOOK_MARKETPLACE,
  FACEBOOK_PROFILE_FEED,
  FACEBOOK_RIGHT_HAND_COLUMN,
  FACEBOOK_SEARCH,
  FACEBOOK_STORY,
  FACEBOOK_VIDEO_FEEDS,
  INSTAGRAM_EXPLORE,
  INSTAGRAM_EXPLORE_HOME,
  INSTAGRAM_IG_SEARCH,
  INSTAGRAM_PROFILE_FEED,
  INSTAGRAM_REELS,
  INSTAGRAM_REELS_OVERLAY,
  INSTAGRAM_STORY,
  INSTAGRAM_STREAM,
  MESSENGER_MESSENGER_HOME,
  MESSENGER_SPONSORED_MESSAGES,
  MESSENGER_STORY
} from './fields'

export const placementPositionTitles = {
  // facebook
  [FACEBOOK_FEED]: 'Facebook Feed',
  [FACEBOOK_MARKETPLACE]: 'Facebook Marketplace',
  [FACEBOOK_PROFILE_FEED]: 'Facebook Profile Feed',
  [FACEBOOK_VIDEO_FEEDS]: 'Facebook video feeds',
  [FACEBOOK_RIGHT_HAND_COLUMN]: 'Facebook Right Column',
  [FACEBOOK_SEARCH]: 'Facebook search results',
  [FACEBOOK_STORY]: 'Facebook Stories',
  [FACEBOOK_INSTREAM_VIDEO]: 'Facebook in-stream videos',
  [FACEBOOK_INSTANT_ARTICLE]: 'Facebook Instant Articles',
  [FACEBOOK_BIZ_DISCO_FEED]: 'Facebook Business Explore',
  [FACEBOOK_FACEBOOK_REELS]: 'Facebook Reels',
  [FACEBOOK_FACEBOOK_REELS_OVERLAY]: 'Ads on Facebook Reels',
  // instagram
  [INSTAGRAM_STORY]: 'Instagram Stories',
  [INSTAGRAM_STREAM]: 'Instagram Feed',
  [INSTAGRAM_PROFILE_FEED]: 'Instagram profile feed',
  [INSTAGRAM_REELS]: 'Instagram Reels',
  [INSTAGRAM_IG_SEARCH]: 'Instagram search results',
  [INSTAGRAM_EXPLORE]: 'Instagram Explore',
  [INSTAGRAM_EXPLORE_HOME]: 'Instagram Explore home',
  [INSTAGRAM_REELS_OVERLAY]: 'Instagram ads in Reels',
  // messenger
  [MESSENGER_MESSENGER_HOME]: 'Messenger inbox',
  [MESSENGER_SPONSORED_MESSAGES]: 'Messenger sponsored messages',
  [MESSENGER_STORY]: 'Messenger Stories',
  // audience network
  [AUDIENCE_NETWORK_INSTREAM_VIDEO]: 'In-stream videos',
  [AUDIENCE_NETWORK_CLASSIC]: 'Audience Network native, banner and interstitial',
  [AUDIENCE_NETWORK_REWARDED_VIDEO]: 'Audience Network rewarded videos'
}
export const placementSafetyRules = {
  brand_safety_content_filter_levels: ['facebook_strict', 'an_strict'],
  excluded_publisher_categories: [
    'dating',
    'gambling',
    'debated_social_issues',
    'mature_audiences',
    'tragedy_and_conflict'
  ]
}
export const placementsObjectiveTable = {
  [FACEBOOK_FEED]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [INSTAGRAM_STREAM]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [INSTAGRAM_PROFILE_FEED]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_MARKETPLACE]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_VIDEO_FEEDS]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_RIGHT_HAND_COLUMN]: {
    [OUTCOME_AWARENESS]: false,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: false
  },
  [INSTAGRAM_EXPLORE]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [INSTAGRAM_EXPLORE_HOME]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [MESSENGER_MESSENGER_HOME]: {
    [OUTCOME_AWARENESS]: false,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_BIZ_DISCO_FEED]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [INSTAGRAM_STORY]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_STORY]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [MESSENGER_STORY]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [INSTAGRAM_REELS]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_FACEBOOK_REELS]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_INSTREAM_VIDEO]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [INSTAGRAM_REELS_OVERLAY]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_FACEBOOK_REELS_OVERLAY]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [FACEBOOK_SEARCH]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [INSTAGRAM_IG_SEARCH]: {
    [OUTCOME_AWARENESS]: true,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: true,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [MESSENGER_SPONSORED_MESSAGES]: {
    [OUTCOME_AWARENESS]: false,
    [OUTCOME_TRAFFIC]: false,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: false,
    [OUTCOME_LEADS]: false,
    [OUTCOME_APP_PROMOTION]: true
  },
  [AUDIENCE_NETWORK_CLASSIC]: {
    [OUTCOME_AWARENESS]: false,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  },
  [AUDIENCE_NETWORK_REWARDED_VIDEO]: {
    [OUTCOME_AWARENESS]: false,
    [OUTCOME_TRAFFIC]: true,
    [OUTCOME_ENGAGEMENT]: false,
    [OUTCOME_SALES]: true,
    [OUTCOME_LEADS]: true,
    [OUTCOME_APP_PROMOTION]: true
  }
}
export const isPlacementActive = (placement, campaignObjective) => {
  return !!placementsObjectiveTable[placement]?.[campaignObjective]
}
export const getFeedsCheckboxOptions = campaignObjective => {
  return [
    {
      name: FACEBOOK_FEED,
      title: placementPositionTitles[FACEBOOK_FEED],
      disabled: !isPlacementActive(FACEBOOK_FEED, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: INSTAGRAM_STREAM,
      title: placementPositionTitles[INSTAGRAM_STREAM],
      disabled: !isPlacementActive(INSTAGRAM_STREAM, campaignObjective),
      titleColor: 'orange'
    },
    {
      name: INSTAGRAM_PROFILE_FEED,
      title: placementPositionTitles[INSTAGRAM_PROFILE_FEED],
      disabled: !isPlacementActive(INSTAGRAM_PROFILE_FEED, campaignObjective),
      titleColor: 'orange'
    },
    {
      name: FACEBOOK_MARKETPLACE,
      title: placementPositionTitles[FACEBOOK_MARKETPLACE],
      disabled: !isPlacementActive(FACEBOOK_MARKETPLACE, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: FACEBOOK_VIDEO_FEEDS,
      title: placementPositionTitles[FACEBOOK_VIDEO_FEEDS],
      disabled: !isPlacementActive(FACEBOOK_VIDEO_FEEDS, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: FACEBOOK_RIGHT_HAND_COLUMN,
      title: placementPositionTitles[FACEBOOK_RIGHT_HAND_COLUMN],
      disabled: !isPlacementActive(FACEBOOK_RIGHT_HAND_COLUMN, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: INSTAGRAM_EXPLORE,
      title: placementPositionTitles[INSTAGRAM_EXPLORE],
      disabled: !isPlacementActive(INSTAGRAM_EXPLORE, campaignObjective),
      titleColor: 'orange'
    },
    {
      name: INSTAGRAM_EXPLORE_HOME,
      title: placementPositionTitles[INSTAGRAM_EXPLORE_HOME],
      disabled: !isPlacementActive(INSTAGRAM_EXPLORE_HOME, campaignObjective),
      titleColor: 'orange'
    },
    {
      name: MESSENGER_MESSENGER_HOME,
      title: placementPositionTitles[MESSENGER_MESSENGER_HOME],
      disabled: !isPlacementActive(MESSENGER_MESSENGER_HOME, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: FACEBOOK_BIZ_DISCO_FEED,
      title: placementPositionTitles[FACEBOOK_BIZ_DISCO_FEED],
      disabled: !isPlacementActive(FACEBOOK_BIZ_DISCO_FEED, campaignObjective),
      titleColor: 'blue'
    }
  ]
}
export const getStoriesAndReelsCheckboxOptions = campaignObjective => {
  return [
    {
      name: INSTAGRAM_STORY,
      title: placementPositionTitles[INSTAGRAM_STORY],
      disabled: !isPlacementActive(INSTAGRAM_STORY, campaignObjective),
      titleColor: 'orange'
    },
    {
      name: FACEBOOK_STORY,
      title: placementPositionTitles[FACEBOOK_STORY],
      disabled: !isPlacementActive(FACEBOOK_STORY, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: MESSENGER_STORY,
      title: placementPositionTitles[MESSENGER_STORY],
      disabled: !isPlacementActive(MESSENGER_STORY, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: INSTAGRAM_REELS,
      title: placementPositionTitles[INSTAGRAM_REELS],
      disabled: !isPlacementActive(INSTAGRAM_REELS, campaignObjective),
      titleColor: 'orange'
    },
    {
      name: FACEBOOK_FACEBOOK_REELS,
      title: placementPositionTitles[FACEBOOK_FACEBOOK_REELS],
      disabled: !isPlacementActive(FACEBOOK_FACEBOOK_REELS, campaignObjective),
      titleColor: 'blue'
    }
  ]
}
export const getInStreamCheckboxOptions = campaignObjective => {
  return [
    {
      name: FACEBOOK_INSTREAM_VIDEO,
      title: placementPositionTitles[FACEBOOK_INSTREAM_VIDEO],
      disabled: !isPlacementActive(FACEBOOK_INSTREAM_VIDEO, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: FACEBOOK_FACEBOOK_REELS_OVERLAY,
      title: placementPositionTitles[FACEBOOK_FACEBOOK_REELS_OVERLAY],
      disabled: !isPlacementActive(FACEBOOK_FACEBOOK_REELS_OVERLAY, campaignObjective),
      titleColor: 'blue'
    }
    // {
    //   // todo SHOP-1744 This one need to be added on BE
    //   name: INSTAGRAM_REELS_OVERLAY,
    //   title: placementPositionTitles[INSTAGRAM_REELS_OVERLAY],
    //   disabled: !isPlacementActive(INSTAGRAM_REELS_OVERLAY, campaignObjective)
    // }
  ]
}
export const getSearchCheckboxOptions = campaignObjective => {
  return [
    {
      name: FACEBOOK_SEARCH,
      title: placementPositionTitles[FACEBOOK_SEARCH],
      disabled: !isPlacementActive(FACEBOOK_SEARCH, campaignObjective),
      titleColor: 'blue'
    },
    {
      name: INSTAGRAM_IG_SEARCH,
      title: placementPositionTitles[INSTAGRAM_IG_SEARCH],
      disabled: !isPlacementActive(INSTAGRAM_IG_SEARCH, campaignObjective),
      titleColor: 'orange'
    }
  ]
}
export const getMessagesCheckboxOptions = campaignObjective => {
  return [
    {
      name: MESSENGER_SPONSORED_MESSAGES,
      title: placementPositionTitles[MESSENGER_SPONSORED_MESSAGES],
      disabled: !isPlacementActive(MESSENGER_SPONSORED_MESSAGES, campaignObjective),
      titleColor: 'blue'
    }
  ]
}
export const getAudienceNetworkCheckboxOptions = campaignObjective => {
  return [
    {
      name: AUDIENCE_NETWORK_CLASSIC,
      title: placementPositionTitles[AUDIENCE_NETWORK_CLASSIC],
      disabled: !isPlacementActive(AUDIENCE_NETWORK_CLASSIC, campaignObjective)
    },
    {
      name: AUDIENCE_NETWORK_REWARDED_VIDEO,
      title: placementPositionTitles[AUDIENCE_NETWORK_REWARDED_VIDEO],
      disabled: !isPlacementActive(AUDIENCE_NETWORK_REWARDED_VIDEO, campaignObjective)
    }
  ]
}
export const getPlacementsList = campaignObjective => {
  return [
    ...getFeedsCheckboxOptions(campaignObjective),
    ...getStoriesAndReelsCheckboxOptions(campaignObjective),
    ...getInStreamCheckboxOptions(campaignObjective),
    ...getSearchCheckboxOptions(campaignObjective),
    ...getMessagesCheckboxOptions(campaignObjective),
    ...getAudienceNetworkCheckboxOptions(campaignObjective)
  ]
}
export const getActivePlacementsInitialValues = campaignObjective => {
  const allPlacementOptions = getPlacementsList(campaignObjective)

  return allPlacementOptions.reduce((acc, item) => {
    acc[item.name] = !item.disabled
    return acc
  }, {})
}

export const getSelectedPlacementPositions = placements => {
  return Object.keys(placements).filter(position => placements[position])
}

export const transformPlacementsToBE = (placements, campaignObjective) => {
  const initialPlacements = getPlacementsList(campaignObjective)
  const activeInitialPlacements = initialPlacements.filter(({ disabled }) => disabled === false)

  const isAllActivePlacementsChecked = activeInitialPlacements.every(placement => !!placements[placement.name])

  return {
    ...(isAllActivePlacementsChecked
      ? // if all active placements are checked, we don't need to send placements to BE
        {}
      : {
          [PLACEMENT_POSITIONS]: getSelectedPlacementPositions(placements)
        })
  }
}
